import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotaFiscalService } from 'src/app/services/fat/nota-fiscal.service';
import fs from 'file-saver';
import { ArquivoUtils } from 'src/app/shared/utils/arquivo-utils';
import { TrataExcessao } from '../../utils/trata-excessao';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CustomSnackBarService } from '../custom-snack-bar/custom-snack-bar.service';

@Component({
  selector: 'app-carta-correcao-modal',
  templateUrl: './carta-correcao-modal.component.html',
  styleUrls: ['./carta-correcao-modal.component.scss']
})
export class CartaCorrecaoModalComponent implements OnInit {
  isLoading = false;
  dialogRef: MatDialogRef<CartaCorrecaoModalComponent>;

  private dialogData = {};

  form: UntypedFormGroup;

  constructor(
    private service: NotaFiscalService,
    private injector: Injector,
    private snackBar: CustomSnackBarService,
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,) { 
    this.dialogRef = this.injector.get(MatDialogRef);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, null);
  }

  closeModal() {
    if (this.form.valid)
    {
      this.dialogRef.close(this.form.controls['desCartaCorrecao'].value);
    }
  }
  ngOnInit(): void {
    this.createForm();
  }

  private createForm() {

    this.form = this.formBuilder.group({
      desCartaCorrecao: [this.dialogData['desCartaCorrecao'], Validators.compose([Validators.required, Validators.minLength(15), Validators.maxLength(1000)])],
    });
  }

  downloadCartaCorrecao(){
    this.isLoading = true;
    this.service.donwloadCartaCorrecao(this.dialogData['idDocumento']).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response?.body?.retorno?.relatorio)
        {
          response.body.retorno.relatorio.forEach((arquivo) => {
            fs.saveAs(ArquivoUtils.converteBase64toBlob(arquivo.arquivo), 
                                                        arquivo.nome);
          })
        }
      },
      error: (err) => {
        this.isLoading = false;
        TrataExcessao.TrataExcessao(err, this.authService, this.snackBar);
      },
    })
  }

}
